import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import useAuth from '../hooks/useAuth'; 

const PrivateRoute = ({ element: Component, roles = [], ...rest }) => {
  const { user } = useAuth(); 
  const location = useLocation();

  // Check if user is authenticated and has the required role
  const isAuthorized = user && (roles.length === 0 || roles.includes(user.role));

  return isAuthorized ? (
    <Component {...rest} />
  ) : (
    <Navigate to="/login" state={{ from: location }} replace />
  );
};

export default PrivateRoute;
